// import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login/login';
// import home from '@/components/home';
import homepc from '@/components/homepc';
import Index from '@/components/Index';
import cookieOperation from '@/common/js/cookieOperation';
import sessionTimeout from '@/common/js/sessionTimeout';

// 钻石管理信息
import diamondInfoList from '@/pages/diamond/diamondInfoList';
import diamondInsert from '@/pages/diamond/diamondInsert';
import diamondLogList from '@/pages/diamond/diamondLogList';
import fileUpload from '@/pages/diamond/fileUpload';
import fileIncrementUpload from '@/pages/diamond/fileIncrementUpload';
import imageUpload from '@/pages/diamond/imageUpload';
// 财务信息
import financialInfoList from '@/pages/financial/financialInfoList';
// 订单信息
import ordersInfoList from '@/pages/ordersInfoList';
// 客户信息
import customerInfoList from '@/pages/customerInfoList';
// 供应商信息
import suppliersInfoList from '@/pages/suppliersInfoList';
// 珠宝饰品信息
import produceInfoList from '@/pages/produce/produceInfoList';
// 采购信息
import diamondInfoList1 from '@/pages/procurement/diamondInfoList';
import fileUpload1 from '@/pages/procurement/fileUpload';
import procurement from '@/pages/procurement/procurement';
import diamondHistoryList1 from '@/pages/procurement/diamondHistoryList';
import financialReportInfoList from '@/pages/procurement/financialReportInfoList';

// 钻石销售清单信息
import diamondShopList from '@/pages/shop/diamondShopList';
import diamondShopListMobile from '@/pages/shop/diamondShopListMobile';
import shopping from '@/pages/shop/shopping';
import shoppingMobile from '@/pages/shop/shoppingMobile';
import myDiamondList from '@/pages/shop/myDiamondList';
import myDiamondListMobile from '@/pages/shop/myDiamondListMobile';

// HK钻石信息
import diamondHKInfoList from '@/pages/hk/diamondHKInfoList';

// 手机端钻石查询
import diamondShopSelect from '@/pages/phone/diamondShopSelect';
import diamondShopListMobilePhone from '@/pages/phone/diamondShopListMobile';
import myDiamondListMobilePhone from '@/pages/phone/myDiamondListMobile';
import shoppingMobilePhone from '@/pages/phone/shoppingMobile';
import personalInfoPhone from '@/pages/phone/personalInfo';
import produceListMobilePhone from '@/pages/phone/produceListMobile';
import produceListMobile from '@/pages/phone/produceListMobile';

// 配置信息
import usermanage from '@/pages/pzxx/usermanage';
import personalInfo from '@/pages/pzxx/personalInfo';
// 404
import notfound from '@/pages/404';

const router = new Router({
    mode: 'hash', // hash 、 history
    base: '/lds',
    routes: [
        {
            path: '',
            redirect: '/login'
        },
        {
            path: '/index',
            name: 'index',
            component: Index,
            meta: {keepAlive: false}
        },
        // 手机端钻石查询条件页面
        {
            path: '/phone/diamondShopSelect',
            name: 'diamondShopSelect',
            component: diamondShopSelect,
            meta: {keepAlive: false}
        },
        // 手机端钻石查询结果页面
        {
            path: '/phone/diamondShopListMobile',
            name: 'diamondShopListMobilePhone',
            component: diamondShopListMobilePhone,
            meta: {keepAlive: false}
        },
        // 手机端钻石查询我的订单
        {
            path: '/phone/myDiamondListMobile',
            name: 'myDiamondListMobilePhone',
            component: myDiamondListMobilePhone,
            meta: {keepAlive: false}
        },
        // 手机端购物车
        {
            path: '/phone/shoppingMobile',
            name: 'shoppingMobilePhone',
            component: shoppingMobilePhone,
            meta: {keepAlive: false}
        },
        // 手机端成品中心
        {
            path: '/phone/produceListMobile',
            name: 'produceListMobilePhone',
            component: produceListMobilePhone,
            meta: {keepAlive: false}
        },
        // 手机端个人中心
        {
            path: '/phone/personalInfo',
            name: 'personalInfoPhone',
            component: personalInfoPhone,
            meta: {keepAlive: false}
        },
        {
            path: '/homepc',
            name: 'homepc',
            component: homepc,
            meta: {keepAlive: false}, // 缓存标志
            // redirect: {path: '/leadership'},
            children: [
                // 钻石搜索
                {
                    path: '/diamond/diamondInfoList',
                    name: 'diamondInfoList',
                    component: diamondInfoList
                },
                {
                    path: '/diamond/diamondInsert',
                    name: 'diamondInsert',
                    component: diamondInsert
                },
                {
                    path: '/diamond/diamondLogList',
                    name: 'diamondLogList',
                    component: diamondLogList
                },
                {
                    path: '/diamond/fileUpload',
                    name: 'fileUpload',
                    component: fileUpload
                },
                {
                    path: '/diamond/fileIncrementUpload',
                    name: 'fileIncrementUpload',
                    component: fileIncrementUpload
                },
                {
                    path: '/diamond/imageUpload',
                    name: 'imageUpload',
                    component: imageUpload
                },
                // 财务信息
                {
                    path: '/financial/financialInfoList',
                    name: 'financialInfoList',
                    component: financialInfoList
                },
                {
                    path: '/ordersInfoList',
                    name: 'ordersInfoList',
                    component: ordersInfoList
                },
                {
                    path: '/customerInfoList',
                    name: 'customerInfoList',
                    component: customerInfoList
                },
                {
                    path: '/suppliersInfoList',
                    name: 'suppliersInfoList',
                    component: suppliersInfoList
                },
                // 珠宝饰品信息
                {
                    path: '/produce/produceInfoList',
                    name: 'produceInfoList',
                    component: produceInfoList
                },
                // 采购钻石调价数据
                {
                    path: '/procurement/diamondInfoList',
                    name: 'diamondInfoList',
                    component: diamondInfoList1
                },
                // 采购上传数据
                {
                    path: '/procurement/fileUpload',
                    name: 'fileUpload',
                    component: fileUpload1
                },
                // 进销存数据
                {
                    path: '/procurement/procurement',
                    name: 'procurement',
                    component: procurement
                },
                // 钻石历史数据
                {
                    path: '/procurement/diamondHistoryList',
                    name: 'diamondHistoryList',
                    component: diamondHistoryList1
                },
                // 财务报表数据
                {
                    path: '/procurement/financialReportInfoList',
                    name: 'financialReportInfoList',
                    component: financialReportInfoList
                },
                // 报错信息
                {
                    path: '/404',
                    name: 'notfound',
                    component: notfound
                },
                // 钻石售卖信息
                {
                    path: '/shop/diamondShopList',
                    name: 'diamondShopList',
                    component: diamondShopList
                },
                // 钻石售卖信息
                {
                    path: '/shop/diamondShopListMobile',
                    name: 'diamondShopListMobile',
                    component: diamondShopListMobile
                },
                // 我的购物车
                {
                    path: '/shop/shopping',
                    name: 'shopping',
                    component: shopping
                },
                // 我的购物车
                {
                    path: '/shop/shoppingMobile',
                    name: 'shoppingMobile',
                    component: shoppingMobile
                },
                // 我的订单
                {
                    path: '/shop/myDiamondList',
                    name: 'myDiamondList',
                    component: myDiamondList
                },
                {
                    path: '/shop/myDiamondListMobile',
                    name: 'myDiamondListMobile',
                    component: myDiamondListMobile
                },
                // 配置信息-用户信息管理
                {
                    path: '/pzxx/usermanage',
                    name: 'usermanage',
                    component: usermanage
                },
                // 配置信息-个人信息管理
                {
                    path: '/pzxx/personalInfo',
                    name: 'personalInfo',
                    component: personalInfo
                },
                // HK钻石信息
                {
                    path: '/hk/diamondHKInfoList',
                    name: 'diamondHKInfoList',
                    component: diamondHKInfoList
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '*',
            redirect: {path: '/404'}
        }
    ]
});

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
    // 检查是否已登录（优先检查 sessionStorage，其次检查 cookie）
    const accessToken = sessionStorage.getItem('access_token') || cookieOperation.cookie.get('access_token');
    const userName = sessionStorage.getItem('userName') || cookieOperation.cookie.get('userName');
    
    // 定义不需要登录的页面路径
    const publicPaths = ['/login', '/404'];
    const isPublicPath = publicPaths.includes(to.path);
    
    // 判断是否为移动端页面路径
    const isPhonePath = to.path.startsWith('/phone/');
    const wasPhonePath = from.path.startsWith('/phone/');
    
    // 如果离开移动端页面，销毁会话超时监控
    if (wasPhonePath && !isPhonePath) {
        if (sessionTimeout && typeof sessionTimeout.destroy === 'function') {
            sessionTimeout.destroy();
        }
    }
    
    // 如果已登录，检查会话超时
    if (accessToken && userName && !isPublicPath) {
        const lastActivityTime = sessionStorage.getItem('lastActivityTime');
        if (lastActivityTime) {
            const idleTime = Date.now() - parseInt(lastActivityTime, 10);
            const timeoutDuration = 60 * 60 * 1000; // 1小时
            
            // 如果超过1小时无操作，清除登录信息并跳转到登录页
            if (idleTime >= timeoutDuration) {
                cookieOperation.cookie.delete('access_token');
                cookieOperation.cookie.delete('userName');
                cookieOperation.cookie.delete('userType');
                cookieOperation.cookie.delete('userDept');
                sessionStorage.clear();
                sessionTimeout.destroy();
                
                // 显示提示信息
                if (window.Vue && window.Vue.prototype.$message) {
                    window.Vue.prototype.$message({
                        message: '登录已超时，请重新登录',
                        type: 'warning',
                        duration: 3000
                    });
                }
                
                next({ path: '/login' });
                return;
            }
        }
        
        // 如果进入移动端页面，初始化会话超时监控
        if (isPhonePath && sessionTimeout && typeof sessionTimeout.init === 'function') {
            sessionTimeout.init();
        }
        
        // 如果已登录且未超时，更新活动时间（路由切换也算活动）
        if (sessionTimeout && typeof sessionTimeout.updateActivityTime === 'function') {
            sessionTimeout.updateActivityTime();
        }
    }
    
    // 如果已登录且访问登录页，根据设备类型重定向到相应首页
    if (accessToken && userName && to.path === '/login') {
        const isMobileDevice = (() => {
            if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
                return navigator.userAgentData.mobile;
            }
            const ua = navigator.userAgent || '';
            const isMobileUA = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(ua);
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            const isNarrowScreen = window.innerWidth <= 1024;
            return isMobileUA || (hasTouch && isNarrowScreen);
        })();
        if (isMobileDevice) {
            next({ path: '/index' });
        } else {
            next({ path: '/homepc' });
        }
        return;
    }
    
    // 如果未登录且访问需要登录的页面，重定向到登录页
    if (!accessToken && !isPublicPath) {
        next({ path: '/login' });
        return;
    }
    
    // 其他情况正常访问
    next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js